import { debugLog } from '@utils';
import { cartSectionManager } from '@services';

class CartItemCount extends HTMLElement {
  connectedCallback() {
    // Subscribe to batched section updates
    this.unsubscribeSectionManager = cartSectionManager.subscribe('fetch-cart-item-count', (html) =>
      this.handleSectionUpdate(html)
    );
  }

  disconnectedCallback() {
    this.unsubscribeSectionManager?.();
  }

  /**
   * Handle section update from CartSectionManager
   * @param {Document} html - Parsed HTML document
   */
  handleSectionUpdate(html) {
    try {
      const target = html.querySelector('cart-item-count');
      if (target) {
        // Update the count text without replacing the entire element
        this.textContent = target.textContent;
        // Update visibility class based on cart state
        const isHidden = target.classList.contains('hidden');
        this.classList.toggle('hidden', isHidden);
      }
    } catch (error) {
      debugLog(error.message);
    }
  }
}

customElements.define('cart-item-count', CartItemCount);
